/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerType } from './PartnerType';
import {
    PartnerTypeFromJSON,
    PartnerTypeFromJSONTyped,
    PartnerTypeToJSON,
    PartnerTypeToJSONTyped,
} from './PartnerType';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';
import type { LanguageEnum } from './LanguageEnum';
import {
    LanguageEnumFromJSON,
    LanguageEnumFromJSONTyped,
    LanguageEnumToJSON,
    LanguageEnumToJSONTyped,
} from './LanguageEnum';
import type { PartnerAddressOutput } from './PartnerAddressOutput';
import {
    PartnerAddressOutputFromJSON,
    PartnerAddressOutputFromJSONTyped,
    PartnerAddressOutputToJSON,
    PartnerAddressOutputToJSONTyped,
} from './PartnerAddressOutput';

/**
 * 
 * @export
 * @interface PartnerOutput
 */
export interface PartnerOutput {
    /**
     * 
     * @type {string}
     * @memberof PartnerOutput
     */
    partnerId?: string;
    /**
     * first name of the partner
     * @type {string}
     * @memberof PartnerOutput
     */
    firstName?: string;
    /**
     * last name of the partner
     * @type {string}
     * @memberof PartnerOutput
     */
    lastName?: string;
    /**
     * 
     * @type {PartnerType}
     * @memberof PartnerOutput
     */
    partnerType?: PartnerType;
    /**
     * the main location of the relationship manager
     * @type {string}
     * @memberof PartnerOutput
     */
    rmLocation?: string;
    /**
     * 
     * @type {PartnerAddressOutput}
     * @memberof PartnerOutput
     */
    partnerAddresses?: PartnerAddressOutput;
    /**
     * the language of the partner
     * @type {Array<LanguageEnum>}
     * @memberof PartnerOutput
     */
    languageCd?: Array<LanguageEnum>;
    /**
     * 
     * @type {CountryCode}
     * @memberof PartnerOutput
     */
    mainDomicileCountryCode?: CountryCode;
    /**
     * if the client is a private individual or a legal entity
     * @type {string}
     * @memberof PartnerOutput
     */
    clientType?: string;
}



/**
 * Check if a given object implements the PartnerOutput interface.
 */
export function instanceOfPartnerOutput(value: object): value is PartnerOutput {
    return true;
}

export function PartnerOutputFromJSON(json: any): PartnerOutput {
    return PartnerOutputFromJSONTyped(json, false);
}

export function PartnerOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerId': json['partnerId'] == null ? undefined : json['partnerId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'partnerType': json['partnerType'] == null ? undefined : PartnerTypeFromJSON(json['partnerType']),
        'rmLocation': json['rmLocation'] == null ? undefined : json['rmLocation'],
        'partnerAddresses': json['partnerAddresses'] == null ? undefined : PartnerAddressOutputFromJSON(json['partnerAddresses']),
        'languageCd': json['languageCd'] == null ? undefined : ((json['languageCd'] as Array<any>).map(LanguageEnumFromJSON)),
        'mainDomicileCountryCode': json['mainDomicileCountryCode'] == null ? undefined : CountryCodeFromJSON(json['mainDomicileCountryCode']),
        'clientType': json['clientType'] == null ? undefined : json['clientType'],
    };
}

export function PartnerOutputToJSON(json: any): PartnerOutput {
    return PartnerOutputToJSONTyped(json, false);
}

export function PartnerOutputToJSONTyped(value?: PartnerOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerId': value['partnerId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'partnerType': PartnerTypeToJSON(value['partnerType']),
        'rmLocation': value['rmLocation'],
        'partnerAddresses': PartnerAddressOutputToJSON(value['partnerAddresses']),
        'languageCd': value['languageCd'] == null ? undefined : ((value['languageCd'] as Array<any>).map(LanguageEnumToJSON)),
        'mainDomicileCountryCode': CountryCodeToJSON(value['mainDomicileCountryCode']),
        'clientType': value['clientType'],
    };
}

